var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report-Editor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RptEd5.3-BarChartSingle",
    transform: "translate(-106.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(106.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    stroke: "#CCCCCC",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "np_bar-chart_1011270_37809F",
    transform: "translate(8.000000, 5.000000)",
    fill: "#37809F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2933156,19.4789281 L12.2797741,19.4789281 L12.2797741,9.91363466 L16.2933156,9.91363466 L16.2933156,19.4789281 Z M22.1831262,19.4789281 L18.1695847,19.4789281 L18.1695847,0.200313841 L22.1831262,0.200313841 L22.1831262,19.4789281 Z M4.51253567,19.4789281 L0.498994175,19.4789281 L0.498994175,15.0013163 L4.51253567,15.0013163 L4.51253567,19.4789281 Z M10.403505,19.4789281 L6.38880477,19.4789281 L6.38880477,5.66023662 L10.4023463,5.66023662 L10.403505,19.4789281 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleColumn);
export default __webpack_public_path__ + "static/media/single_column.7c97d9ab51cf1af22da23ae4f13ff85b.svg";
export { ForwardRef as ReactComponent };